export function DownloadCircleIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.6908 4.51998C29.7308 2.09998 26.0708 0.499976 22.0508 0.0999756V4.13998C24.9708 4.49998 27.6308 5.65998 29.8508 7.37998L32.6908 4.51998ZM35.9108 18H39.9508C39.5508 13.98 37.9508 10.32 35.5308 7.35998L32.6708 10.2C34.3908 12.42 35.5508 15.08 35.9108 18ZM32.6708 29.8L35.5308 32.66C37.9508 29.7 39.5508 26.02 39.9508 22.02H35.9108C35.5508 24.92 34.3908 27.58 32.6708 29.8ZM22.0508 35.86V39.9C26.0708 39.5 29.7308 37.9 32.6908 35.48L29.8308 32.62C27.6308 34.34 24.9708 35.5 22.0508 35.86ZM27.2308 17.18L22.0508 22.34V9.99998H18.0508V22.34L12.8708 17.16L10.0508 20L20.0508 30L30.0508 20L27.2308 17.18ZM18.0508 35.86V39.9C7.95078 38.9 0.0507812 30.38 0.0507812 20C0.0507812 9.61998 7.95078 1.09998 18.0508 0.0999756V4.13998C10.1508 5.11998 4.05078 11.84 4.05078 20C4.05078 28.16 10.1508 34.88 18.0508 35.86Z"
        fill="#3D424B"
      />
    </svg>
  )
}

export function DesignerIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M36.6783 9.80249C37.4583 9.02249 37.4583 7.76249 36.6783 6.98249L31.0183 1.32249C30.2383 0.542488 28.9783 0.542488 28.1983 1.32249L19.2183 10.3025L11.4383 2.52249C9.87828 0.962488 7.33828 0.962488 5.77828 2.52249L1.97828 6.32249C0.418281 7.88249 0.418281 10.4225 1.97828 11.9825L9.75828 19.7625L0.738281 28.7825V37.2625H9.21828L18.2583 28.2225L26.0383 36.0025C27.9383 37.9025 30.4983 37.2025 31.6983 36.0025L35.4983 32.2025C37.0583 30.6425 37.0583 28.1025 35.4983 26.5425L27.7183 18.7625L36.6783 9.80249ZM4.81828 9.14249L8.59828 5.34249L11.1383 7.88249L8.77828 10.2625L11.5983 13.0825L13.9783 10.7025L16.3783 13.1025L12.5783 16.9025L4.81828 9.14249ZM27.2783 24.0225L24.8983 26.4025L27.7183 29.2225L30.0983 26.8425L32.6383 29.3825L28.8383 33.1825L21.0583 25.4025L24.8583 21.6025L27.2783 24.0225ZM7.55828 33.2625H4.73828V30.4425L23.9583 11.2225L26.7783 14.0425L7.55828 33.2625ZM26.7783 8.38249L29.5983 5.56249L32.4183 8.38249L29.5983 11.2025L26.7783 8.38249Z"
        fill="#3D424B"
      />
    </svg>
  )
}

export function DriveUploadIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="40"
      height="32"
      viewBox="0 0 40 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M36 4H20L16 0H4C1.8 0 0.02 1.8 0.02 4L0 28C0 30.2 1.8 32 4 32H36C38.2 32 40 30.2 40 28V8C40 5.8 38.2 4 36 4ZM36 28H4V4H14.34L18.34 8H36V28ZM14.82 20.84L18 17.68V26H22V17.68L25.18 20.86L28 18.02L20.02 10L12 18.02L14.82 20.84Z"
        fill="#3D424B"
      />
    </svg>
  )
}

export function GroupsIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="48"
      height="24"
      viewBox="0 0 48 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 14C10.2 14 12 12.2 12 10C12 7.8 10.2 6 8 6C5.8 6 4 7.8 4 10C4 12.2 5.8 14 8 14ZM10.26 16.2C9.52 16.08 8.78 16 8 16C6.02 16 4.14 16.42 2.44 17.16C0.96 17.8 0 19.24 0 20.86V24H9V20.78C9 19.12 9.46 17.56 10.26 16.2ZM40 14C42.2 14 44 12.2 44 10C44 7.8 42.2 6 40 6C37.8 6 36 7.8 36 10C36 12.2 37.8 14 40 14ZM48 20.86C48 19.24 47.04 17.8 45.56 17.16C43.86 16.42 41.98 16 40 16C39.22 16 38.48 16.08 37.74 16.2C38.54 17.56 39 19.12 39 20.78V24H48V20.86ZM32.48 15.3C30.14 14.26 27.26 13.5 24 13.5C20.74 13.5 17.86 14.28 15.52 15.3C13.36 16.26 12 18.42 12 20.78V24H36V20.78C36 18.42 34.64 16.26 32.48 15.3ZM16.14 20C16.32 19.54 16.4 19.22 17.96 18.62C19.9 17.86 21.94 17.5 24 17.5C26.06 17.5 28.1 17.86 30.04 18.62C31.58 19.22 31.66 19.54 31.86 20H16.14ZM24 4C25.1 4 26 4.9 26 6C26 7.1 25.1 8 24 8C22.9 8 22 7.1 22 6C22 4.9 22.9 4 24 4ZM24 0C20.68 0 18 2.68 18 6C18 9.32 20.68 12 24 12C27.32 12 30 9.32 30 6C30 2.68 27.32 0 24 0Z"
        fill="#3D424B"
      />
    </svg>
  )
}

export function SchoolIconFill(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.96909 7.11746V8.99079C1.96909 9.47746 2.23576 9.93079 2.66243 10.1641L5.99576 11.9841C6.39576 12.2041 6.87576 12.2041 7.27576 11.9841L10.6091 10.1641C11.0358 9.93079 11.3024 9.47746 11.3024 8.99079V7.11746L7.27576 9.31746C6.87576 9.53746 6.39576 9.53746 5.99576 9.31746L1.96909 7.11746ZM5.99576 0.677456L0.375762 3.74412C-0.0842383 3.99746 -0.0842383 4.66412 0.375762 4.91746L5.99576 7.98412C6.39576 8.20412 6.87576 8.20412 7.27576 7.98412L12.6358 5.05746V8.99746C12.6358 9.36412 12.9358 9.66412 13.3024 9.66412C13.6691 9.66412 13.9691 9.36412 13.9691 8.99746V4.72412C13.9691 4.47746 13.8358 4.25746 13.6224 4.13746L7.27576 0.677456C6.87576 0.464123 6.39576 0.464123 5.99576 0.677456Z"
        fill="#272B2F"
      />
    </svg>
  )
}

export function PaletteFillIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.38448 0.156124C3.27823 0.762374 0.775107 3.25925 0.162607 6.35612C-0.993643 12.1999 4.27823 16.5561 8.25011 15.9405C9.53761 15.7405 10.1689 14.2342 9.57823 13.0749C8.85636 11.6561 9.88761 9.99987 11.4814 9.99987H13.972C15.0907 9.99987 15.997 9.07487 16.0001 7.95925C15.9845 3.03425 11.5032 -0.840751 6.38448 0.156124ZM3.00011 9.99987C2.44698 9.99987 2.00011 9.553 2.00011 8.99987C2.00011 8.44675 2.44698 7.99987 3.00011 7.99987C3.55323 7.99987 4.00011 8.44675 4.00011 8.99987C4.00011 9.553 3.55323 9.99987 3.00011 9.99987ZM4.00011 5.99987C3.44698 5.99987 3.00011 5.553 3.00011 4.99987C3.00011 4.44675 3.44698 3.99987 4.00011 3.99987C4.55323 3.99987 5.00011 4.44675 5.00011 4.99987C5.00011 5.553 4.55323 5.99987 4.00011 5.99987ZM8.00011 3.99987C7.44698 3.99987 7.00011 3.553 7.00011 2.99987C7.00011 2.44675 7.44698 1.99987 8.00011 1.99987C8.55323 1.99987 9.00011 2.44675 9.00011 2.99987C9.00011 3.553 8.55323 3.99987 8.00011 3.99987ZM12.0001 5.99987C11.447 5.99987 11.0001 5.553 11.0001 4.99987C11.0001 4.44675 11.447 3.99987 12.0001 3.99987C12.5532 3.99987 13.0001 4.44675 13.0001 4.99987C13.0001 5.553 12.5532 5.99987 12.0001 5.99987Z"
        fill="#272B2F"
      />
    </svg>
  )
}

export function ContentInterestsIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.4999 1.33329C16.5749 1.04163 15.5583 0.916626 14.5833 0.916626C12.9583 0.916626 11.2083 1.24996 9.99992 2.16663C8.79159 1.24996 7.04159 0.916626 5.41659 0.916626C3.79159 0.916626 2.04159 1.24996 0.833252 2.16663V15.0833C2.04159 14.1666 3.79159 13.8333 5.41659 13.8333C7.04159 13.8333 8.79159 14.1666 9.99992 15.0833C11.2083 14.1666 12.9583 13.8333 14.5833 13.8333C15.5583 13.8333 16.5749 13.9583 17.4999 14.25C18.1249 14.4583 18.6666 14.7083 19.1666 15.0833V2.16663C18.6666 1.79163 18.1249 1.54163 17.4999 1.33329ZM17.4999 12.5833C16.5833 12.2916 15.5833 12.1666 14.5833 12.1666C13.1666 12.1666 11.1249 12.7083 9.99992 13.4166V3.83329C11.1249 3.12496 13.1666 2.58329 14.5833 2.58329C15.5833 2.58329 16.5833 2.70829 17.4999 2.99996V12.5833Z"
        fill="#3D424B"
      />
      <path
        d="M14.5833 5.91663C15.3166 5.91663 16.0249 5.99163 16.6666 6.13329V4.86663C16.0083 4.74163 15.2999 4.66663 14.5833 4.66663C13.1666 4.66663 11.8833 4.90829 10.8333 5.35829V6.74163C11.7749 6.20829 13.0833 5.91663 14.5833 5.91663Z"
        fill="#3D424B"
      />
      <path
        d="M10.8333 7.57496V8.95829C11.7749 8.42496 13.0833 8.13329 14.5833 8.13329C15.3166 8.13329 16.0249 8.20829 16.6666 8.34996V7.08329C16.0083 6.95829 15.2999 6.88329 14.5833 6.88329C13.1666 6.88329 11.8833 7.13329 10.8333 7.57496Z"
        fill="#3D424B"
      />
      <path
        d="M14.5833 9.10829C13.1666 9.10829 11.8833 9.34996 10.8333 9.79996V11.1833C11.7749 10.65 13.0833 10.3583 14.5833 10.3583C15.3166 10.3583 16.0249 10.4333 16.6666 10.575V9.30829C16.0083 9.17496 15.2999 9.10829 14.5833 9.10829Z"
        fill="#3D424B"
      />
    </svg>
  )
}

export function WarningIconFill(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="30"
      height="26"
      viewBox="0 0 30 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.70494 25.7556H26.2949C28.6049 25.7556 30.0449 23.2506 28.8899 21.2556L17.5949 1.74063C16.4399 -0.254365 13.5599 -0.254365 12.4049 1.74063L1.10994 21.2556C-0.0450622 23.2506 1.39494 25.7556 3.70494 25.7556ZM14.9999 15.2556C14.1749 15.2556 13.4999 14.5806 13.4999 13.7556V10.7556C13.4999 9.93064 14.1749 9.25564 14.9999 9.25564C15.8249 9.25564 16.4999 9.93064 16.4999 10.7556V13.7556C16.4999 14.5806 15.8249 15.2556 14.9999 15.2556ZM16.4999 21.2556H13.4999V18.2556H16.4999V21.2556Z"
        fill="#B91236"
      />
    </svg>
  )
}

export function ToolsStudioIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.9984 28.6899C13.504 28.6899 13.0702 28.3914 12.893 27.9296L10.4489 21.5784C10.0183 20.4559 9.88454 20.1356 9.68398 19.8557C9.48964 19.5821 9.25021 19.3411 8.97035 19.1406C8.69205 18.9447 8.37178 18.8094 7.24613 18.3756L0.898046 15.9331C0.442502 15.759 0.13623 15.3128 0.13623 14.8261C0.13623 14.3395 0.440948 13.8964 0.898046 13.7207L7.24613 11.2766C8.34845 10.8537 8.68894 10.7122 8.9688 10.5117C9.25021 10.3142 9.48964 10.0717 9.68398 9.79647C9.88143 9.51662 10.026 9.17923 10.4489 8.07536L12.893 1.72262C13.0671 1.26863 13.5102 0.962341 13.9984 0.962341C14.4866 0.962341 14.9313 1.26708 15.1054 1.72262L17.548 8.07536C17.9817 9.19944 18.117 9.51973 18.3129 9.79647C18.5103 10.0763 18.7529 10.3173 19.0312 10.5117C19.3095 10.7091 19.6469 10.8537 20.7523 11.2766L27.1035 13.7207C27.5575 13.8948 27.8638 14.3379 27.8638 14.8261C27.8638 15.3143 27.559 15.759 27.1035 15.9331L20.7523 18.3756C19.6251 18.8094 19.3064 18.9447 19.0312 19.1406C18.7529 19.3365 18.5119 19.579 18.3129 19.8542C18.1185 20.1309 17.9817 20.4497 17.548 21.5784L15.1054 27.9296C14.9313 28.3836 14.4882 28.6899 13.9984 28.6899Z"
        fill="white"
      />
    </svg>
  )
}

export function ToolsFlowIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="19"
      viewBox="0 0 24 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.014 10.7802L4.38112 18.4131C3.85356 18.9406 3.00048 18.9406 2.47853 18.4131L1.21013 17.1447C0.682562 16.6171 0.682562 15.764 1.21013 15.2421L6.62046 9.83174L1.21013 4.4214C0.682562 3.89384 0.682562 3.04075 1.21013 2.5188L2.47291 1.23918C3.00048 0.711615 3.85356 0.711615 4.37551 1.23918L12.0084 8.87202C12.5415 9.39959 12.5415 10.2527 12.014 10.7802ZM22.7897 8.87202L15.1569 1.23918C14.6293 0.711615 13.7763 0.711615 13.2543 1.23918L11.9859 2.50758C11.4583 3.03514 11.4583 3.88822 11.9859 4.41018L17.3962 9.82052L11.9859 15.2309C11.4583 15.7584 11.4583 16.6115 11.9859 17.1335L13.2543 18.4018C13.7819 18.9294 14.6349 18.9294 15.1569 18.4018L22.7897 10.769C23.3173 10.2527 23.3173 9.39959 22.7897 8.87202Z"
        fill="white"
      />
    </svg>
  )
}

export function ToolsVectorizerIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="22"
      height="26"
      viewBox="0 0 22 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.732 3.19408C21.732 1.49552 20.3537 0.117173 18.6551 0.117173C16.9566 0.117173 15.5782 1.49552 15.5782 3.19408C15.5782 3.89485 15.8242 4.52369 16.2187 5.04115L11.1949 19.0497C11.1323 19.0497 11.0719 19.0241 10.9977 19.0241C10.935 19.0241 10.8863 19.0357 10.826 19.0357L5.82772 5.0017C6.19668 4.49585 6.41944 3.86933 6.41944 3.19176C6.41944 1.4932 5.0411 0.114853 3.34253 0.114853C1.64397 0.114853 0.265625 1.4932 0.265625 3.19176C0.265625 4.73021 1.398 5.98557 2.8622 6.21994L8.30364 20.6484C8.06927 21.08 7.92308 21.5836 7.92308 22.1126C7.92308 23.8112 9.30143 25.1895 11 25.1895C12.6986 25.1895 14.0769 23.8112 14.0769 22.1126C14.0769 21.5952 13.9284 21.1033 13.7079 20.6716L19.1378 6.21994C20.602 5.98557 21.7344 4.73021 21.7344 3.19176L21.732 3.19408Z"
        fill="white"
      />
    </svg>
  )
}

export function ToolsFontGeneratorIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="22"
      height="25"
      viewBox="0 0 22 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.2882 21.2154L11.3523 23.9764H7.55602C6.63571 23.9764 5.7873 23.9764 5.7873 23.9764C5.32714 23.9764 4.95327 23.6025 4.95327 23.1423C4.95327 22.6534 4.95327 22.1789 4.95327 21.69C4.95327 21.2442 5.32714 20.8703 5.77292 20.8703C6.16118 20.8703 6.54943 20.8703 6.93769 20.8703C7.22529 20.8703 7.46975 20.6115 7.46975 20.3239C7.46975 20.0938 7.46975 19.8637 7.46975 19.6193L9.48293 20.3958C9.64111 20.4533 9.9287 20.5683 10.0725 20.6259C10.1013 20.6978 10.2307 21.0285 10.2882 21.2011V21.2154ZM10.0581 12.7313C10.1156 12.5875 10.2451 12.2855 10.2882 12.1561L11.3811 9.32328V3.77265H15.2636C15.5512 3.77265 15.7957 4.01711 15.7957 4.30471C15.7957 4.69296 15.7957 5.08122 15.7957 5.46948C15.7957 5.91525 16.1696 6.28913 16.6153 6.28913C17.1043 6.28913 17.5788 6.28913 18.0677 6.28913C18.5279 6.28913 18.8874 5.91525 18.9017 5.4551C18.9017 5.4551 18.9017 1.96079 18.9017 1.48625C18.9017 1.0261 18.5279 0.666602 18.0677 0.652222C17.9239 0.652222 17.7657 0.652222 17.5932 0.652222H14.9473H1.31516C1.1426 0.652222 0.970043 0.652222 0.840624 0.652222C0.380468 0.652222 0.0065918 1.0261 0.0065918 1.48625C0.0065918 1.97517 0.0065918 5.4551 0.0065918 5.4551C0.0065918 5.91525 0.380468 6.28913 0.840624 6.28913C1.32954 6.28913 1.80408 6.28913 2.29299 6.28913C2.73877 6.28913 3.11264 5.91525 3.11264 5.46948C3.11264 5.08122 3.11264 4.69296 3.11264 4.30471C3.11264 4.01711 3.3571 3.78703 3.6447 3.77265H7.57041V13.6948L9.49731 12.947C9.65549 12.8895 9.9287 12.7745 10.0725 12.7169L10.0581 12.7313ZM21.562 16.0531L17.9095 14.6438C17.2768 14.3994 17.0755 14.3131 16.9173 14.1981C16.7591 14.083 16.6153 13.9536 16.5003 13.781C16.3853 13.6229 16.3134 13.4359 16.0545 12.7888L14.6453 9.13634C14.5446 8.87751 14.2858 8.70495 14.0126 8.70495C13.7394 8.70495 13.4805 8.87751 13.3799 9.13634L11.9706 12.7888C11.7262 13.4215 11.6399 13.6229 11.5249 13.781C11.4817 13.8386 11.4242 13.8817 11.3811 13.9248C11.2948 14.0111 11.2229 14.1118 11.1222 14.1837C10.9641 14.2987 10.7627 14.385 10.13 14.6295L7.55602 15.6217L6.46315 16.0387C6.20432 16.1393 6.01738 16.3982 6.01738 16.6714C6.01738 16.9446 6.18994 17.2034 6.46315 17.3041L7.55602 17.7211L10.13 18.7133C10.7771 18.9578 10.9641 19.0441 11.1222 19.1591C11.2517 19.2454 11.3523 19.3604 11.4386 19.4755C11.4674 19.5042 11.5105 19.533 11.5249 19.5617C11.6399 19.7199 11.7118 19.9069 11.9706 20.554L12.0857 20.8559L13.2792 23.962L13.3799 24.2208C13.4805 24.4797 13.725 24.6522 14.0126 24.6522C14.3002 24.6522 14.5446 24.4797 14.6453 24.2208L16.0545 20.5683C16.299 19.9212 16.3853 19.7343 16.5003 19.5761C16.6153 19.4179 16.7591 19.2741 16.9173 19.1591C17.0755 19.0441 17.2624 18.9722 17.9095 18.7133L21.562 17.3041C21.8209 17.2034 21.9934 16.9446 21.9934 16.6714C21.9934 16.3982 21.8209 16.1393 21.562 16.0387V16.0531Z"
        fill="white"
      />
    </svg>
  )
}

export function ToolsBackgroundRemoverIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="30"
      height="33"
      viewBox="0 0 30 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.1778 17.1892L25.8379 11.6264C25.5896 11.8634 25.3188 12.0665 25.0029 12.2357L24.9239 12.2809L24.8336 12.3147L20.8393 13.917C20.591 14.0185 20.4556 14.0749 20.3654 14.1088L20.2977 14.1765C20.2638 14.2668 20.1961 14.4022 20.1058 14.6504L18.5262 18.5996C18.0861 19.8182 17.0029 20.5968 15.7504 20.5968C14.6446 20.5968 13.6178 19.9198 13.0649 18.814L12.9295 18.5432L12.8844 18.4417L12.8506 18.3401L11.5191 14.8761L11.4965 14.8309V14.7858L11.4176 14.6053L9.92813 15.4967L3.89146 19.1187C1.61219 20.484 0.867482 23.4628 2.23279 25.7421L4.87312 30.1314C6.23843 32.4106 9.21727 33.1553 11.4965 31.79L17.5332 28.168L28.0381 21.8718C29.6517 20.9015 30.182 18.8027 29.2116 17.1892H29.1778ZM10.0184 29.3754C9.07058 29.9395 7.84068 29.6349 7.26522 28.6871L4.62489 24.2978C4.06071 23.35 4.36537 22.1201 5.31318 21.5446L9.74759 18.8817L14.4528 26.7125L10.0184 29.3754ZM6.6672 9.14406C6.6672 8.87325 6.938 8.61373 7.19752 8.47833L8.39357 8.08341L11.3273 7.01148C11.993 6.74067 12.2638 6.61656 12.5233 6.48115C12.6587 6.48115 12.6587 6.34575 12.7941 6.21035L12.9295 6.07495C13.0649 5.93955 13.2003 5.68003 13.4599 5.00302L15.0621 1.00866C15.1975 0.613734 15.457 0.478333 15.7278 0.478333C15.9987 0.478333 16.2582 0.749136 16.3936 1.00866L17.9958 5.00302C18.2666 5.66874 18.3908 5.93955 18.5262 6.07495C18.5262 6.21035 18.797 6.34575 18.9211 6.46987C19.0452 6.59399 19.316 6.74067 19.993 7.00019L23.9874 8.60245C24.2582 8.73785 24.5177 8.99737 24.5177 9.53898C24.5177 9.80978 24.2469 10.0693 23.9874 10.2047L19.993 11.807C19.3273 12.0778 19.0565 12.2019 18.9211 12.3373C18.7857 12.3373 18.6503 12.6081 18.5262 12.7322C18.402 12.8563 18.2554 13.1271 17.9958 13.8041L16.3936 17.7985C16.2582 18.1934 15.9987 18.3288 15.7278 18.3288C15.457 18.3288 15.1975 18.058 15.0621 17.7985L14.9267 17.5277L13.5953 14.0637L13.4599 13.6687C13.1891 13.003 13.0649 12.7322 12.9295 12.5968C12.9295 12.4614 12.7941 12.4614 12.7941 12.4614L12.3992 12.0665C12.2638 11.9311 12.0043 11.7957 11.3273 11.5362L8.39357 10.2047L7.19752 9.80979C6.8026 9.67438 6.6672 9.41486 6.6672 9.14406ZM2.10867 14.3232L0.991601 13.8154L0.540261 13.6687C0.393576 13.6236 0.337158 13.5221 0.337158 13.4205C0.337158 13.319 0.43871 13.2174 0.540261 13.1723L0.991601 13.0256L2.10867 12.6194C2.3569 12.5178 2.45846 12.4727 2.56001 12.4163C2.60514 12.4163 2.60514 12.3711 2.66156 12.3147L2.70669 12.2696C2.70669 12.2696 2.80824 12.1229 2.9098 11.8634L3.5191 10.3401C3.56424 10.1934 3.66579 10.137 3.76734 10.137C3.86889 10.137 3.97044 10.2386 4.01558 10.3401L4.62489 11.8634C4.72644 12.1116 4.77157 12.2132 4.82799 12.2696C4.82799 12.3147 4.92954 12.3711 4.97468 12.4163C5.01981 12.4614 5.12136 12.5178 5.38088 12.6194L6.90415 13.2287C7.0057 13.2738 7.10726 13.3754 7.10726 13.5785C7.10726 13.68 7.0057 13.7816 6.90415 13.8267L5.38088 14.436C5.13264 14.5376 5.03109 14.5827 4.97468 14.6391C4.92954 14.6391 4.87312 14.7407 4.82799 14.7858C4.78286 14.8309 4.72644 14.9325 4.62489 15.192L4.01558 16.7153C3.97044 16.862 3.86889 16.9184 3.76734 16.9184C3.66579 16.9184 3.56424 16.8168 3.5191 16.7153L3.47397 16.6137L2.96621 15.2936L2.92108 15.1469C2.81953 14.8986 2.77439 14.7971 2.71798 14.7407C2.71798 14.6955 2.67284 14.6955 2.67284 14.6955L2.52616 14.5489C2.52616 14.5489 2.37947 14.4473 2.11995 14.3458L2.10867 14.3232Z"
        fill="white"
      />
    </svg>
  )
}
